<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <a class="apply-btn" href="/#/newvisa">Apply Now</a>
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>
            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box">
                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <ul>
                                        <li><a href="#/covid">COVID - 19 Protocols</a></li>
                                        <li><a href="#/visaprocess">Visa Process</a></li>
                                        <li><a href="#/appterms">Visa Application Terms</a></li>
                                        <li><a class="active" href="#/needvisa">Do I Need a Visa</a></li>
                                        <li><a href="#/req_photo">Photo Requirements</a></li>
                                        <li><a href="#/req_passport">Passport Requirements</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-8 offset-md-1">
                            <div class="static top98">
                                <CheckCountry></CheckCountry>
                                <h3 class="top32">List of countries that require visa to enter Botswana:</h3>
                                <div class="country-list">
                                    <div class="country-item" v-for="item in countries1">
                                        <div class="flags" v-bind:style="{ backgroundImage: 'url(images/flags/' + item.Code + '.png)' }">{{item.Description}}</div>
                                    </div>
                                </div>
                                <div class="country-list">
                                    <div class="country-item" v-for="item in countries2">
                                        <div class="flags" v-bind:style="{ backgroundImage: 'url(images/flags/' + item.Code + '.png)' }">{{item.Description}}</div>
                                    </div>
                                </div>
                                <div class="country-list">
                                    <div class="country-item" v-for="item in countries3">
                                        <div class="flags" v-bind:style="{ backgroundImage: 'url(images/flags/' + item.Code + '.png)' }">{{item.Description}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <ul>
                            <li><a href="#/covid">COVID - 19 Protocols</a></li>
                            <li><a href="#/visaprocess">Visa Process</a></li>
                            <li><a href="#/appterms">Visa Application Terms</a></li>
                            <li><a class="active" href="#/needvisa">Do I Need a Visa</a></li>
                            <li><a href="#/req_photo">Photo Requirements</a></li>
                            <li><a href="#/req_passport">Passport Requirements</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                  
                       
                            <CheckCountry></CheckCountry>
                            <h3 class="top32">List of countries that require visa to enter Botswana:</h3>
                            <div class="country-list">
                                <div class="country-item" v-for="item in countries1">
                                    <div class="flags" v-bind:style="{ backgroundImage: 'url(images/flags/' + item.Code + '.png)' }">{{item.Description}}</div>
                                </div>
                            </div>
                            <div class="country-list">
                                <div class="country-item" v-for="item in countries2">
                                    <div class="flags" v-bind:style="{ backgroundImage: 'url(images/flags/' + item.Code + '.png)' }">{{item.Description}}</div>
                                </div>
                            </div>
                            <div class="country-list">
                                <div class="country-item" v-for="item in countries3">
                                    <div class="flags" v-bind:style="{ backgroundImage: 'url(images/flags/' + item.Code + '.png)' }">{{item.Description}}</div>
                                </div>
                            </div>
                        
                   
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CheckCountry from "./CheckCountry";
    import TopMenu from "./Menu";
    export default {
        name: 'NeedVisa',
        components: { CheckCountry, TopMenu },
        data: () => ({
            countries: {},
            countries1: {},
            countries2: {},
            countries3: {},
        }),
        mounted() {
            this.getCountries()
        },
        computed: {
        },
        methods: {
            async getCountries() {
                try {
                    //console.log(this.$apiip);
                    const response = await fetch(this.$apiip + '/api/v1/application/needvisa')
                    const data = await response.json()
                    this.countries = JSON.parse(data)
                    var length = Math.floor(this.countries.length/3)
                    this.countries1 = this.countries.slice(0, length);
                    this.countries2 = this.countries.slice(length, 2 * length);
                    this.countries3 = this.countries.slice(2 * length, this.countries.length);
                    //console.log(this.countries.length)
                } catch (error) {
                    //console.error(error)
                }
            },
        }
    }
</script>